/**
 * <s-header-compact>
 * Placed inside the site header. Sets `data-compact` on the closest <header> once the
 * visitor has scrolled down a little, and removes it back near the top, so the sticky
 * header can shrink while scrolling. A small gap between the two thresholds avoids
 * flickering when the header height changes.
 */
class HeaderCompact extends HTMLElement {
  #header = null;
  #ticking = false;

  connectedCallback() {
    this.#header = this.closest('header');
    if (!this.#header) return;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }

  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#ticking = false;
      this.#update();
    });
  };

  #update = () => {
    const y = window.scrollY;
    const isCompact = this.#header.hasAttribute('data-compact');
    if (!isCompact && y > 60) this.#header.setAttribute('data-compact', '');
    else if (isCompact && y < 20) this.#header.removeAttribute('data-compact');
  };
}

if (!customElements.get('s-header-compact')) {
  customElements.define('s-header-compact', HeaderCompact);
}
